import { Grid } from "@mui/material";
import React from "react";
import { IMaterial, IMaterialGroup } from "../../interfaces";

export const MaterialIdentifiers: React.FC<{ material?: IMaterial, materialGroup?: IMaterialGroup }> = ({
    material,
    materialGroup,
    ...props
}) => {

    const wrapperStyle = {
        width: '260px'
    }

    const idStyle = {
        justifyContent: 'space-between',
        borderBottom: '1px solid lightgrey'
    }

    const emptyMaterial: IMaterial = {
        partNumber: undefined,
        catalogueNumber: undefined,
        manufacturerNumber: undefined,
        serialNumber: undefined,
        vehicleNumber: undefined,
        unitNumber: undefined,
        porterbrookAssetNumber: undefined,
        unitOfQuantity: {},
        images: []
    }

    const identifierMaterial: IMaterial = materialGroup ? {
        ...emptyMaterial,
        partNumber: materialGroup.partNumber,
        catalogueNumber: materialGroup.catalogueNumber,
    } : material ? material : emptyMaterial;

    return (
        <>
            <Grid container sx={wrapperStyle}>

                <Grid container sx={idStyle} display={identifierMaterial.partNumber ? "auto" : "none"}>
                    <Grid item><small><em>Part Number</em></small> </Grid>
                    <Grid item> {identifierMaterial.partNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.catalogueNumber ? "auto" : "none"}>
                    <Grid item><small><em>Catalogue Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.catalogueNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.manufacturerNumber ? "auto" : "none"}>
                    <Grid item><small><em>Manufacturer Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.manufacturerNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.serialNumber ? "auto" : "none"}>
                    <Grid item><small><em>Serial Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.serialNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.vehicleNumber ? "auto" : "none"}>
                    <Grid item><small><em>Vehicle Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.vehicleNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.unitNumber ? "auto" : "none"}>
                    <Grid item><small><em>Unit Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.unitNumber}</Grid>
                </Grid>

                <Grid container sx={idStyle} display={identifierMaterial.porterbrookAssetNumber ? "auto" : "none"}>
                    <Grid item><small><em>Porterbrook Asset Number</em></small> </Grid>
                    <Grid item>{identifierMaterial.porterbrookAssetNumber}</Grid>
                </Grid>

            </Grid>
        </>
    );
}

